function permissionKeyForStore(key) {
  if (typeof key !== 'string') return key;
  if (key.includes('_')) return key;
  return key.replace(/([A-Z])/g, (match) => `_${match.toLowerCase()}`).replace(/^_/, '');
}

/**
 * @param {Record<string, boolean|undefined|null>|null|undefined} permissions
 * @returns {Record<string, boolean>}
 */
export function normalizeRolePermissions(permissions) {
  if (!permissions || typeof permissions !== 'object') return {};
  return Object.fromEntries(
    Object.entries(permissions).map(([key, value]) => [permissionKeyForStore(key), !!value]),
  );
}
